<script>
    import Router from 'svelte-spa-router';
    import { modalCanUseHistoryBack } from '../store';

    import Tab1 from "./Vault/Saved.svelte";
    import Tab2 from "./Vault/YourIdeas.svelte";
    // import Tab3 from "./Vault/Drafts.svelte";
    import Tabs from "../components/organisms/Tabs/Tabs.svelte";

    // This checks, wether another route (like this one) was opened, before the modal was opened.
    // When opening a deeplink to a modal directly, this remains false and therefore closing the overlay will not use history.back() (e.g. to prevent going back to google.com), instead it just routes to "/"
    $modalCanUseHistoryBack = true;

    // List of tab items with labels, values and assigned components

    const routes = {
      '/vault': Tab1,
      '/yours': Tab2,
      // '/drafts': Tab3,
    };

    // List of tab items with labels, values and assigned components
    const tabs = [
      { 
        label: "Liked",
        value: 1,
        route: "/vault",
        tab: 'vault',
        context: 'vault'
      },
      { 
        label: "Your ideas",
        value: 2,
        route: '/yours',
        tab: 'yours',
        context: 'vault'
      },
      // { 
      //   label: "Drafts",
      //   value: 2,
      //   route: '/drafts',
      //   tab: 'drafts',
      //   context: 'vault'
      // }
    ];
</script>

<Tabs {tabs}/>
<Router {routes} />